import React, { useEffect } from 'react'
import { useNavigate } from "react-router";
import { useStateValue } from '../context/StateValueContext';

interface ProtectedProps {
  isSignedIn?: boolean;
  permission?: string | string[];
  authInitialized?: boolean;
  mustChangePassword?: boolean;
  children: React.ReactNode;
}

function Protected({ isSignedIn, permission, authInitialized, mustChangePassword, children }: ProtectedProps) {
  const navigate = useNavigate();
  const [{ user }] = useStateValue();

  // Don't redirect until auth state has been initialized
  const shouldRedirectToSignIn = authInitialized !== false && isSignedIn !== undefined && !isSignedIn;
  const shouldRedirectToSetPassword = mustChangePassword === true;
  const shouldRedirectHome =
    permission !== undefined &&
    !(Array.isArray(permission)
      ? permission.some(p => user?.permissions?.includes(p))
      : user?.permissions?.includes(permission));

  useEffect(() => {
    if (shouldRedirectToSignIn) {
      navigate('/signin', { replace: true });
    }
  }, [shouldRedirectToSignIn, navigate]);

  useEffect(() => {
    if (shouldRedirectToSetPassword) {
      navigate('/set-password', { replace: true });
    }
  }, [shouldRedirectToSetPassword, navigate]);

  useEffect(() => {
    if (shouldRedirectHome) {
      navigate('/', { replace: true });
    }
  }, [shouldRedirectHome, navigate]);

  if (isSignedIn === undefined && permission === undefined) {
    return null;
  }

  // Show nothing while auth is initializing to prevent flash
  if (authInitialized === false && isSignedIn !== undefined) {
    return null;
  }

  // safety in case I forgot to provide the protection args
  if (shouldRedirectToSignIn || shouldRedirectToSetPassword || shouldRedirectHome) {
    return null;
  }

  return <>{children}</>;
}

export default Protected;
